import { IdCodeLibelle } from '../../id-code-libelle.abstract.model';

export class StatutControle extends IdCodeLibelle {}
